import { FaPlus } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { actAddDeck } from '../store/cards/action';
import { Link } from 'react-router-dom';
import useDuplicate from '../hooks/useDuplicate';
import useAlert from '../hooks/useAlert';

const Card = ({ card, isHome }) => {
  const dispatch = useDispatch()
  const duplicated = useDuplicate(card.id)
  const swal = useAlert

  const addCard = () => {
    if (duplicated) {
      dispatch(actAddDeck(card))
      swal('success', 'A Card Has Been added to Deck')
    } else {
      swal('error', 'This card already in your Deck')
    }
  }

  return (
    <div className="p-4 md:w-1/2 lg:w-1/3 xl:w-1/4 2xl:w-1/5">
      <div className="h-full border-2 bg-gray-100 bg-opacity-90 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
        <img className=" w-full object-cover object-center" src={ card.card_images[0].image_url } alt="blog" />
        <div className="p-6">
          <div className="mb-3 flex">
            <div className="flex-1">
              <h2 className="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">{ card.attribute }</h2>
              <p className="title-font text-lg font-medium text-gray-900 line-clamp-1">{ card.name }</p>
            </div>
            {
              isHome && (
                <button onClick={ addCard } className="text-center text-green-500">
                  <FaPlus className="text-3xl " />
                  <p className="text-sm">Add</p>
                </button>
              )
            }

          </div>
          <div className="flex items-center flex-wrap ">
            <button className="text-blue-500 ">
              <Link to={`/monster/${card.id}`} className="inline-flex items-center md:mb-2 lg:mb-0">
                <span>Detail</span>
                <svg className="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14"></path>
                  <path d="M12 5l7 7-7 7"></path>
                </svg>
              </Link>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Card